export const REQUEST_CHECK_OBJECT = 'aws/REQUEST_CHECK_OBJECT' as const;
export const REQUEST_CHECK_OBJECT_SUCCESS = 'aws/REQUEST_CHECK_OBJECT_SUCCESS' as const;
export const REQUEST_CHECK_OBJECT_FAILURE = 'aws/REQUEST_CHECK_OBJECT_FAILURE' as const;
